import { render, staticRenderFns } from "./Lessonplan.vue?vue&type=template&id=81f107f0"
import script from "./Lessonplan.vue?vue&type=script&lang=js"
export * from "./Lessonplan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports